module.exports = __webpack_public_path__ + "img/bet-switch.50d9e14a.svg";